import React, { Component } from "react";
import Header from "../components/Head";
import Subscribe from "../components/Subscribe";
import AboutPageContent from "../components/About";
import { withTranslate } from "react-redux-multilingual"
import globalMiddleware from "./../hocs/globalMiddleware";
import {setCurrentRoute, clearError500} from "../store/actions/globalActions";
import {connect} from "react-redux";


class About extends Component{
    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.setCurrentRoute(window.location.href);
        this.props.clearError500();
    }
    render() {

        const history = [
            {
                page:  this.props.translate("home"),
                to: "/"
            }
        ];

        return (
            <div className="About">
                <Header title={ this.props.translate("about") } history={ history } />
                <AboutPageContent/>
                <Subscribe />
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return {
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        setCurrentRoute: (route) => dispatch(setCurrentRoute(route)),
        clearError500: () => dispatch(clearError500()),
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(globalMiddleware(withTranslate(About)));